<template>
  <div style="margin: 0;padding: 0;">
    <el-header style="height: 45px;margin: 0;padding: 0;color: #ffffff;width: 100%;overflow: hidden;">
      <div style="width: 100%;min-height: 45px;max-height: 55px;">
        <div style="display: inline-block;margin-right: 20px;vertical-align: top;">
          <el-input v-model="serchat" placeholder="请输入客户名称" maxlength="30" style="width: 150px;"></el-input>
          <el-dropdown split-button type="primary" @command="commandEvent">
            <span v-html="dropdownTitle"></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="全部">全部</el-dropdown-item>
              <el-dropdown-item v-for="(item,index) in dropdownList" :key="index" :command="item.label">{{item.label}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" @click="isAjax" plain>查询</el-button>
        </div>
        <el-button type="success" size="small" style="float: right;" @click="tp" v-show="isTpShow">投屏<i class="el-icon-copy-document el-icon--right"></i></el-button>
      </div>
    </el-header>
    <el-container>
      <el-main>
        <select style="position: fixed;top:55px;left: 10px;z-index: 1;" id="checkValue">
          <option>全部</option>
          <option>2019</option>
          <option>2018</option>
          <option>2017</option>
        </select>
        <el-button type="primary" size="mini" style="position: fixed;top:55px;left: 70px;z-index: 1;" @click="returnChina">返回全国</el-button>
        <br/>
        <div style="width: 100%;">
          <div id="myChart" :style="divHeight"></div>
        </div>
      </el-main>
      <el-footer>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
  import MacaronsProject from '@/assets/macaronsProject.js'
  var echarts = require('echarts/lib/echarts');
  require('echarts/map/js/china') // 引入中国地图数据
  require('echarts/map/js/world') // 引入世界地图数据
  export default {
    name: 'App',
    data () {
      return {
        myChart:null,
        isTpShow:true,
        dropdownList:[],
        serchat:"",
        dropdownTitle:"请选择",
        divHeight:{
          width: '100%', height: '615px',float:'left'
        },
        clickLength:35,
        cityList:[],
        provincesText:['上海', '河北', '山西', '内蒙古', '辽宁', '吉林', '黑龙江', '江苏', '浙江', '安徽', '福建', '江西', '山东', '河南', '湖北', '湖南', '广东', '广西', '海南', '四川', '贵州', '云南', '西藏', '陕西', '甘肃', '青海', '宁夏', '新疆', '北京', '天津', '重庆', '香港', '澳门'],
        provinces:['shanghai', 'hebei', 'shanxi', 'neimenggu', 'liaoning', 'jilin', 'heilongjiang', 'jiangsu', 'zhejiang', 'anhui', 'fujian', 'jiangxi', 'shandong', 'henan', 'hubei', 'hunan', 'guangdong', 'guangxi', 'hainan', 'sichuan', 'guizhou', 'yunnan', 'xizang', 'shanxi1', 'gansu', 'qinghai', 'ningxia', 'xinjiang', 'beijing', 'tianjin', 'chongqing', 'xianggang', 'aomen'],
        // 全国省份数据
        toolTipDataCopy:[],
        toolTipData:[
          {
          "provinceName": "北京",
          "provinceKey": 110000,
          "cityName": null,
          "cityKey": null,
          "shopCount": 0,
          "totalPrice": 0,
          "orderCount": 0,
          "onlineCount": 0
        }, {
          "provinceName": "天津",
          "provinceKey": 120000,
          "cityName": null,
          "cityKey": null,
          "shopCount": 0,
          "totalPrice": 0,
          "orderCount": 0,
          "onlineCount": 0
        }, {
          "provinceName": "河北",
          "provinceKey": 130000,
          "cityName": null,
          "cityKey": null,
          "shopCount": 0,
          "totalPrice": 0,
          "orderCount": 0,
          "onlineCount": 0
        }, {
          "provinceName": "山西",
          "provinceKey": 140000,
          "cityName": null,
          "cityKey": null,
          "shopCount": 0,
          "totalPrice": 0,
          "orderCount": 0,
          "onlineCount": 0
        }, {
          "provinceName": "内蒙古",
          "provinceKey": 150000,
          "cityName": null,
          "cityKey": null,
          "shopCount": 0,
          "totalPrice": 0,
          "orderCount": 0,
          "onlineCount": 0
        }, {
          "provinceName": "辽宁",
          "provinceKey": 210000,
          "cityName": null,
          "cityKey": null,
          "shopCount": 0,
          "totalPrice": 0,
          "orderCount": 0,
          "onlineCount": 0
        }, {
          "provinceName": "吉林",
          "provinceKey": 220000,
          "cityName": null,
          "cityKey": null,
          "shopCount": 0,
          "totalPrice": 0,
          "orderCount": 0,
          "onlineCount": 0
        }, {
          "provinceName": "黑龙江",
          "provinceKey": 230000,
          "cityName": null,
          "cityKey": null,
          "shopCount": 0,
          "totalPrice": 0,
          "orderCount": 0,
          "onlineCount": 0
        }, {
          "provinceName": "上海",
          "provinceKey": 310000,
          "cityName": null,
          "cityKey": null,
          "shopCount": 0,
          "totalPrice": 0,
          "orderCount": 0,
          "onlineCount": 0
        }, {
          "provinceName": "江苏",
          "provinceKey": 320000,
          "cityName": null,
          "cityKey": null,
            "shopCount": 0,
            "totalPrice": 0,
            "orderCount": 0,
          "onlineCount": 0
        }, {
          "provinceName": "浙江",
          "provinceKey": 330000,
          "cityName": null,
          "cityKey": null,
            "shopCount": 0,
            "totalPrice": 0,
            "orderCount": 0,
          "onlineCount": 0
        }, {
          "provinceName": "安徽",
          "provinceKey": 340000,
          "cityName": null,
          "cityKey": null,
            "shopCount": 0,
            "totalPrice": 0,
            "orderCount": 0,
          "onlineCount": 0
        }, {
          "provinceName": "福建",
          "provinceKey": 350000,
          "cityName": null,
          "cityKey": null,
            "shopCount": 0,
            "totalPrice": 0,
            "orderCount": 0,
          "onlineCount": 0
        }, {
          "provinceName": "江西",
          "provinceKey": 360000,
          "cityName": null,
          "cityKey": null,
            "shopCount": 0,
            "totalPrice": 0,
            "orderCount": 0,
          "onlineCount": 0
        }, {
          "provinceName": "山东",
          "provinceKey": 370000,
          "cityName": null,
          "cityKey": null,
            "shopCount": 0,
            "totalPrice": 0,
            "orderCount": 0,
          "onlineCount": 0
        }, {
          "provinceName": "河南",
          "provinceKey": 410000,
          "cityName": null,
          "cityKey": null,
            "shopCount": 0,
            "totalPrice": 0,
            "orderCount": 0,
          "onlineCount": 0
        }, {
          "provinceName": "湖北",
          "provinceKey": 420000,
          "cityName": null,
          "cityKey": null,
            "shopCount": 0,
            "totalPrice": 0,
            "orderCount": 0,
          "onlineCount": 0
        }, {
          "provinceName": "湖南",
          "provinceKey": 430000,
          "cityName": null,
          "cityKey": null,
            "shopCount": 0,
            "totalPrice": 0,
            "orderCount": 0,
          "onlineCount": 0
        }, {
          "provinceName": "广东",
          "provinceKey": 440000,
          "cityName": null,
          "cityKey": null,
            "shopCount": 0,
            "totalPrice": 0,
            "orderCount": 0,
          "onlineCount": 0
        }, {
          "provinceName": "广西",
          "provinceKey": 450000,
          "cityName": null,
          "cityKey": null,
            "shopCount": 0,
            "totalPrice": 0,
            "orderCount": 0,
          "onlineCount": 0
        }, {
          "provinceName": "海南",
          "provinceKey": 460000,
          "cityName": null,
          "cityKey": null,
            "shopCount": 0,
            "totalPrice": 0,
            "orderCount": 0,
          "onlineCount": 0
        }, {
          "provinceName": "重庆",
          "provinceKey": 500000,
          "cityName": null,
          "cityKey": null,
            "shopCount": 0,
            "totalPrice": 0,
            "orderCount": 0,
          "onlineCount": 0
        }, {
          "provinceName": "四川",
          "provinceKey": 510000,
          "cityName": null,
          "cityKey": null,
            "shopCount": 0,
            "totalPrice": 0,
            "orderCount": 0,
          "onlineCount": 0
        }, {
          "provinceName": "贵州",
          "provinceKey": 520000,
          "cityName": null,
          "cityKey": null,
            "shopCount": 0,
            "totalPrice": 0,
            "orderCount": 0,
          "onlineCount": 0
        }, {
          "provinceName": "云南",
          "provinceKey": 530000,
          "cityName": null,
          "cityKey": null,
            "shopCount": 0,
            "totalPrice": 0,
            "orderCount": 0,
          "onlineCount": 0
        }, {
          "provinceName": "西藏",
          "provinceKey": 540000,
          "cityName": null,
          "cityKey": null,
            "shopCount": 0,
            "totalPrice": 0,
            "orderCount": 0,
          "onlineCount": 0
        }, {
          "provinceName": "陕西",
          "provinceKey": 610000,
          "cityName": null,
          "cityKey": null,
            "shopCount": 0,
            "totalPrice": 0,
            "orderCount": 0,
          "onlineCount": 0
        }, {
          "provinceName": "甘肃",
          "provinceKey": 620000,
          "cityName": null,
          "cityKey": null,
            "shopCount": 0,
            "totalPrice": 0,
            "orderCount": 0,
          "onlineCount": 0
        }, {
          "provinceName": "青海",
          "provinceKey": 630000,
          "cityName": null,
          "cityKey": null,
            "shopCount": 0,
            "totalPrice": 0,
            "orderCount": 0,
          "onlineCount": 0
        }, {
          "provinceName": "宁夏",
          "provinceKey": 640000,
          "cityName": null,
          "cityKey": null,
            "shopCount": 0,
            "totalPrice": 0,
            "orderCount": 0,
          "onlineCount": 0
        }, {
          "provinceName": "新疆",
          "provinceKey": 650000,
          "cityName": null,
          "cityKey": null,
          "shopCount": 0,
          "totalPrice": 0,
          "orderCount": 0,
          "onlineCount": 0
        }],
        seriesData:[],
        // 请求省市数据，传递provinceKey进行ajax请求 province(key)
        provinceData:[
          {
          "provinceName": null,
          "provinceKey": null,
          "cityName": "乌鲁木齐市",
          "cityKey": 650100,
          "shopCount": 17,
          "totalPrice": 89429.1,
          "orderCount": 4019,
          "onlineCount": 0
        }, {
          "provinceName": null,
          "provinceKey": null,
          "cityName": "克拉玛依市",
          "cityKey": 650200,
          "shopCount": 1,
          "totalPrice": 363.6,
          "orderCount": 17,
          "onlineCount": 0
        }, {
          "provinceName": null,
          "provinceKey": null,
          "cityName": "昌吉回族自治州",
          "cityKey": 652300,
          "shopCount": 3,
          "totalPrice": 2203.7,
          "orderCount": 82,
          "onlineCount": 0
        }, {
          "provinceName": null,
          "provinceKey": null,
          "cityName": "博尔塔拉蒙古自治州",
          "cityKey": 652700,
          "shopCount": 1,
          "totalPrice": 7327.7,
          "orderCount": 236,
          "onlineCount": 0
        }, {
          "provinceName": null,
          "provinceKey": null,
          "cityName": "巴音郭楞蒙古自治州",
          "cityKey": 652800,
          "shopCount": 2,
          "totalPrice": 28768.4,
          "orderCount": 961,
          "onlineCount": 0
        }, {
          "provinceName": null,
          "provinceKey": null,
          "cityName": "阿克苏地区",
          "cityKey": 652900,
          "shopCount": 5,
          "totalPrice": 78415.2,
          "orderCount": 3108,
          "onlineCount": 0
        }, {
          "provinceName": null,
          "provinceKey": null,
          "cityName": "喀什地区",
          "cityKey": 653100,
          "shopCount": 4,
          "totalPrice": 38870.1,
          "orderCount": 1477,
          "onlineCount": 0
        }, {
          "provinceName": null,
          "provinceKey": null,
          "cityName": "和田地区",
          "cityKey": 653200,
          "shopCount": 1,
          "totalPrice": 10488,
          "orderCount": 218,
          "onlineCount": 0
        }, {
          "provinceName": null,
          "provinceKey": null,
          "cityName": "伊犁哈萨克自治州",
          "cityKey": 654000,
          "shopCount": 6,
          "totalPrice": 32864.2,
          "orderCount": 1363,
          "onlineCount": 0
        }, {
          "provinceName": null,
          "provinceKey": null,
          "cityName": "塔城地区",
          "cityKey": 654200,
          "shopCount": 1,
          "totalPrice": 160,
          "orderCount": 5,
          "onlineCount": 0
        }, {
          "provinceName": null,
          "provinceKey": null,
          "cityName": "省直辖行政单位",
          "cityKey": 659000,
          "shopCount": 2,
          "totalPrice": 5533.4,
          "orderCount": 255,
          "onlineCount": 0
        }],
        seriesDataPro:[],
        provList:[],
        max:0,
        min:0,
        maxSize4Pin:40,
        minSize4Pin:30,
        mapName:''
      }
    },
    methods: {
      unitConvert(num) {
        if (num) {
          var moneyUnits = ["", "万"],
            dividend = 10000,
            curentNum = num, //转换数字
            curentUnit = moneyUnits[0]; //转换单位
          for (var i = 0; i < 2; i++) {
            curentUnit = moneyUnits[i];
            if (this.strNumSize(curentNum) < 5) {
              return num;
            }
          }
          curentNum = curentNum / dividend;
          var m = {
            num: 0,
            unit: ""
          }
          m.num = curentNum.toFixed(2);
          m.unit = curentUnit;
          return m.num + m.unit;
        }else{
          return '0万';
        }
      },
      strNumSize(tempNum) {
        var stringNum = tempNum.toString()
        var index = stringNum.indexOf(".")
        var newNum = stringNum
        if (index != -1) {
          newNum = stringNum.substring(0, index)
        }
        return newNum.length;
      },
      getGeoCoordMap(name) {
        name = name ? name : 'china';
        /*获取地图数据*/
        var geoCoordMap = {};
        this.myChart.showLoading(); // loading start
        var mapFeatures = echarts.getMap(name).geoJson.features;
        this.myChart.hideLoading(); // loading end
        mapFeatures.forEach(function(v) {
          var name = v.properties.name; // 地区名称
          geoCoordMap[name] = v.properties.cp; // 地区经纬度
        });
        return geoCoordMap;
      },
      convertData(data) { // 转换数据
        var geoCoordMap = this.getGeoCoordMap(this.mapName);
        var res = [];
        for (var i = 0; i < data.length; i++) {
          var geoCoord = geoCoordMap[data[i].name]; // 数据的名字对应的经纬度
          if (geoCoord) { // 如果数据data对应上，
            res.push({
              name: data[i].name,
              value: geoCoord.concat(data[i].value),
            });
          }
        }
        return res;
      },
      commandEvent(command) {
        this.dropdownTitle = command
      },
      addClass:async function(){
        await this.$axios.post('/data/addClass',{
          uid:""
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.dropdownList = response.data[0];
          }else if(response.data.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
      },
      showProvince(pName, Chinese_) {
        //这写省份的js都是通过在线构建工具生成的，保存在本地，需要时加载使用即可，最好不要一开始全部直接引入。
        var _this = this;
        _this.loadBdScript(pName, function() {
          _this.chinamap(_this.mapName);
          var _list = _this.myChart.getOption().geo[0].regions;
          _this.cityList =_list.slice(_this.clickLength,_list.length)
          if(!_this.provList[Chinese_]){
            _this.provList[Chinese_] = _this.cityList;
          }
          _this.$nextTick (function () {
            _this.isAjax();
          })
        });

      },
      loadBdScript(scriptId, callback) {
        require('echarts/map/js/province/'+scriptId) // 引入世界地图数据
        callback();
      },
      isAjax:async function(){
        if(this.mapName!=""){
          await this.$axios.post('/data/getRegionData',{
            d:this.dropdownTitle,
            s:this.serchat,
            city:this.mapName,
            provData:"",
            cityData:JSON.stringify(this.provList[this.mapName])
          }).then((response,err) => {
            response = response.data;
            if(response.code == "Login" || response.code == "WhiteList"){
              this.$message.error(response.message);
            }else if(response.code == "Success"){
              this.provinceData = response.data[0];
              for (var i = 0; i < this.provinceData.length; i++) {
                this.seriesDataPro[i] = {};
                this.seriesDataPro[i].name = this.provinceData[i].cityName;
                this.seriesDataPro[i].value = this.provinceData[i].orderCount;
              }
              this.max = Math.max.apply(Math, this.seriesDataPro.map(function(o) {
                return o.value
              }));
              this.min = 0; // 侧边最大值最小值
              this.maxSize4Pin = 40;
              this.minSize4Pin = 30;
              this.chinamap(this.mapName);
            }else if(response.data.code == "Fail"){
              this.$message({
                message: response.message,
                type: 'warning'
              });
            }else{
              this.$message({
                message: response.message,
                type: 'warning'
              });
            }
          }).catch(function (error) {
            this.$message.error(error);
          });

        }else{
          await this.$axios.post('/data/getRegionData',{
            d:this.dropdownTitle,
            s:this.serchat,
            city:'',
            provData:JSON.stringify(this.toolTipData),
            cityData:""
          }).then((response,err) => {
            response = response.data;
            if(response.code == "Login" || response.code == "WhiteList"){
              this.$message.error(response.message);
            }else if(response.code == "Success"){
              this.toolTipDataCopy = response.data[0];
              for (var i = 0; i < this.toolTipDataCopy.length; i++) {
                this.seriesData[i] = {};
                this.seriesData[i].name = this.toolTipDataCopy[i].provinceName;
                this.seriesData[i].value = this.toolTipDataCopy[i].orderCount;
                this.seriesData[i].provinceKey = this.toolTipDataCopy[i].provinceKey;
              }
              /*for (var i = 0; i < this.provinceData.length; i++) {
                this.seriesDataPro[i] = {};
                this.seriesDataPro[i].name = this.provinceData[i].cityName;
                this.seriesDataPro[i].value = this.provinceData[i].shopCount;
              }*/
              this.chinamap("china", "中国");
            }else if(response.data.code == "Fail"){
              this.$message({
                message: response.message,
                type: 'warning'
              });
            }else{
              this.$message({
                message: response.message,
                type: 'warning'
              });
            }
          }).catch(function (error) {
            this.$message.error(error);
          });
        }
      },
      //随机生成颜色
      handleColors(){
        //定义字符串变量colorValue存放可以构成十六进制颜色值的值
        var colorValue="0,1,2,3,4,5,6,7,8,9,a,b,c,d,e,f";
        //以","为分隔符，将colorValue字符串分割为字符数组["0","1",...,"f"]
        var colorArray = colorValue.split(",");
        var color="#";//定义一个存放十六进制颜色值的字符串变量，先将#存放进去
        //使用for循环语句生成剩余的六位十六进制值
        for(var i=0;i<6;i++){
          //colorArray[Math.floor(Math.random()*16)]随机取出
          // 由16个元素组成的colorArray的某一个值，然后将其加在color中，
          //字符串相加后，得出的仍是字符串
          color+=colorArray[Math.floor(Math.random()*16)];
        }
        return color;
      },
      chinamap(pName, Chinese_){

        if(pName == 'china'){
          this.max = Math.max.apply(Math, this.seriesData.map(function(o) {
            return o.value
          }));
          this.min = 0; // 侧边最大值最小值
          this.maxSize4Pin = 40;
          this.minSize4Pin = 30;
        }


        var _this = this;
        var tmpSeriesData = pName === "china" ? _this.seriesData : _this.seriesDataPro;
        var tmp = pName === "china" ? (_this.toolTipDataCopy.length == 0?_this.toolTipData:_this.toolTipDataCopy) : _this.provinceData;
        var option= {
          title: {
            text: Chinese_ || pName,
            left: 'center'
          },
          tooltip : {
            trigger: 'item',
            formatter: function(params) { // 鼠标滑过显示的数据
              if (pName === "china") {
                var toolTiphtml = ''
                for (var i = 0; i < tmp.length; i++) {
                  if (params.name == tmp[i].provinceName) {
                    toolTiphtml += tmp[i].provinceName + '<br>销售额：' + _this.unitConvert(tmp[i].totalPrice) + '<br>订单数：' + tmp[i].orderCount + '单' + '<br>采购商数：' + tmp[i].shopCount;
                  }
                }
                return toolTiphtml;
              } else {
                var toolTiphtml = ''
                for (var i = 0; i < tmp.length; i++) {
                  if (params.name == tmp[i].cityName) {
                    toolTiphtml += tmp[i].cityName + '<br>销售额：' + _this.unitConvert(tmp[i].totalPrice) + '<br>订单数：' + tmp[i].orderCount + '单' + '<br>采购商数：' + tmp[i].shopCount;
                  }
                }
                return toolTiphtml;
              }
            }
          },
          visualMap: { //视觉映射组件
            show: true,
            min: _this.min,
            max: _this.max, // 侧边滑动的最大值，从数据中获取
            left: '5%',
            top: '86%',
            inverse: true, //是否反转 visualMap 组件
            // itemHeight:200,  //图形的高度，即长条的高度
            text: ['高', '低'], // 文本，默认为数值文本
            calculable: false, //是否显示拖拽用的手柄（手柄能拖拽调整选中范围）
            seriesIndex: 1, //指定取哪个系列的数据，即哪个系列的 series.data,默认取所有系列
            orient: "horizontal",
            inRange: {
              color: ['#dbfefe', '#1066d5'] // 蓝绿
            }
          },
          geo: {
            show: true,
            map: pName,
            roam: false,
            label: {
              normal: {
                show: false
              },
              emphasis: {
                show: false,
              }
            },
            itemStyle: {
              normal: {
                areaColor: '#3c8dbc', // 没有值得时候颜色
                borderColor: '#097bba',
              },
              emphasis: {
                areaColor: '#fbd456', // 鼠标滑过选中的颜色
              }
            }
          },
          //配置属性
          series: [{
            name: '散点',
            type: 'scatter',
            coordinateSystem: 'geo',
            data: tmpSeriesData,
            symbolSize: '1',
            label: {
              normal: {
                show: true,
                formatter: '{b}',
                position: 'right'
              },
              emphasis: {
                show: true
              }
            },
            itemStyle: {
              normal: {
                color: '#895139' // 字体颜色
              }
            }
          },
            {
              name: Chinese_ || pName,
              type: 'map',
              mapType: pName,
              roam: false, //是否开启鼠标缩放和平移漫游
              data: tmpSeriesData,
              // top: "3%",//组件距离容器的距离
              // geoIndex: 0,
              // aspectScale: 0.75,       //长宽比
              // showLegendSymbol: false, // 存在legend时显示
              selectedMode: 'single',
              label: {
                normal: {
                  show: true, //显示省份标签
                  textStyle: {
                    color: "#6C1B7F"
                  }
                },
                emphasis: { //对应的鼠标悬浮效果
                  show: true,
                  textStyle: {
                    color: "#323232"
                  }
                }
              },
              itemStyle: {
                normal: {
                  borderWidth: .5, //区域边框宽度
                  borderColor: '#0550c3', //区域边框颜色
                  areaColor: "#0b7e9e", //区域颜色
                },
                emphasis: {
                  borderWidth: .5,
                  borderColor: '#4b0082',
                  areaColor: "#ece39e",
                }
              }
            },
            {
              name: '点',
              type: 'scatter',
              coordinateSystem: 'geo',
              symbol: 'pin', //气泡
              symbolSize: function(val) {
                var a = (_this.maxSize4Pin - _this.minSize4Pin) / (_this.max - _this.min);
                var b = _this.minSize4Pin - a * _this.min;
                b = _this.maxSize4Pin - a * _this.max;
                return a * val[2] + b;
              },
              label: {
                normal: {
                  show: true,
                  formatter: function(params) {
                    return params.data.value[2];
                  },
                  textStyle: {
                    color: '#fff',
                    fontSize: 9
                  }
                }
              },
              itemStyle: {
                normal: {
                  color: 'red' //标志颜色'#F62157'
                }
              },
              zlevel: 6,
              data: _this.convertData(tmpSeriesData),
            },
          ]
        };
        // 针对海南放大
        if (pName == '海南') {
          option.series[1].center = [109.844902, 19.0392];
          option.series[1].layoutCenter = ['50%', '50%'];
          option.series[1].layoutSize = "300%";
        } else if(pName == 'china'){ //非显示海南时，将设置的参数恢复默认值
          option.series[1].center = [104.31, 35.85];
          option.series[1].layoutCenter = undefined;
          option.series[1].layoutSize = undefined;
        }else{
          option.series[1].center = undefined;
          option.series[1].layoutCenter = undefined;
          option.series[1].layoutSize = undefined;
        }
        /**
         *  使用刚指定的配置项和数据显示图表。
         *  */
        _this.myChart.setOption(option);
        window.addEventListener('resize', function () {
          _this.myChart.resize()
        })
        /*_this.myChart.on('mouseover', function (params) {
          console.log(params)
          var dataIndex = params.dataIndex;
        });*/
        _this.myChart.off("click");
        if (pName === "china") { // 全国时，添加click 进入省级
          _this.myChart.on('click', function (param) {
            if (param.data && param.data.provinceKey) {
              var key = param.data.provinceKey;
              // province(key);  省份请求
              if (_this.provinceData.length) {
                // 遍历取到provincesText 中的下标  去拿到对应的省js
                for (var i = 0; i < _this.provincesText.length; i++) {
                  if (param.name === _this.provincesText[i]) {
                    _this.clickLength = _this.myChart.getOption().geo[0].regions.length;
                    _this.mapName = _this.provincesText[i];
                    //显示对应省份的方法
                    _this.showProvince(_this.provinces[i], _this.provincesText[i]);
                    break;
                  }
                }
              }
            }
          });
        } else { // 省份，添加双击 回退到全国
          /*_this.myChart.on("dblclick", function () {
            _this.mapName = '';
            _this.chinamap("china", "中国");
          });*/
        }
      },
      returnChina(){
        if(this.mapName!=''){
          this.mapName = '';
          this.chinamap("china", "中国");
        }
      },
      tp(){
        window.open(location.href+"?t=1","_blank");
      },
      GetUrlParms() {
        var args = new Object();
        var query = location.search.substring(1); //获取查询串
        var pairs = query.split("&"); //在逗号处断开
        for (var i = 0; i < pairs.length; i++) {
          var pos = pairs[i].indexOf('='); //查找name=value
          if (pos == -1) continue; //如果没有找到就跳过
          var argname = pairs[i].substring(0, pos); //提取name
          var value = pairs[i].substring(pos + 1); //提取value
          args[argname] = value; //存为属性
        }
        return args;

      }
    },
    mounted() {
      var args=this.GetUrlParms();
      var t = args["t"];
      if(t != null){
        if(t == 1){
          this.isTpShow = false;
        }
      }
      this.addClass();
      this.$echarts.registerTheme('macarons', MacaronsProject)
      this.myChart = this.$echarts.init(document.getElementById('myChart'))
      this.isAjax();

    },
    created () {

    },
    watch: {

    }
  }

</script>
<style scoped>
  .el-main{
    overflow: hidden;
    padding: 0 !important;
    margin: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/dataStatistics/orderRegionKanban.vue